import React, { MouseEventHandler, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store/actions/action";
import moment from "moment";
import SVG from "src/utils/SVG";
import cn from "classnames";
import styled from "styled-components";
import StatusTag from "../common/StatusTag";

interface ListProp {
  data?: any;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const AsListItem = (props: ListProp) => {
  const datas = props.data.data.data;

  const meta = props.data.data.meta;

  const [openTab, setOpenTab] = useState(0);

  const dispatch = useAppDispatch();

  const [page, setPage] = useState({
    totalPages: meta.totalPages,
    pageArray: [],
  });

  useEffect(() => {
    setPage({
      ...page,
      totalPages: meta.totalPages,
    });
  }, [meta]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const { totalPages } = page;

  return (
    <>
      {datas.length > 0 ? (
        <>
          {datas.map((v: any, idx: any) => {
            return (
              <li key={idx}>
                <AsListItemSet to={"/as-detail/" + v.as_idx}>
                  <div className="category-info">
                    <p className="category">{v.cate_name}</p>
                    <StatusTag value={v.progress_name} level={v.progress_value} cancel={v.delete_yn === "Y"} />
                  </div>
                  <div className="content-info">
                    <p className="summary">
                      {v.copy_yn === "Y" ? <RemarkCom>{v.company_name}</RemarkCom> : ""}
                      {v.contents}
                    </p>
                  </div>
                  <div className="sub-info">
                    <p>
                      <span className="shop-type">{v.store_type}</span>
                      <span className="shop-name">{v.store_name}</span>
                    </p>
                    <p>
                      <span className="date">{moment(v.insert_date).format("YYYY.MM.DD")}</span>
                      <span className={cn("chat", { new: v.comment_read_yn === "N" })}>
                        {v.comment_read_yn === "N" ? (
                          <SVG name="chatActive" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                        ) : (
                          <SVG name="chat" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                        )}
                        {v.commentCount}
                      </span>
                    </p>
                  </div>
                </AsListItemSet>
              </li>
            );
          })}
        </>
      ) : (
        <NoResult>리스트 결과가 없습니다.</NoResult>
      )}
    </>
  );
};

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

const AsListItemSet = styled(Link)`
  display: block;
  padding: 16px 0;
  > div:first-child {
    ${({ theme }) => theme.flexBox.flexMixin()}
  }
  > div:last-child {
    ${({ theme }) => theme.flexBox.flexMixin()}
  }
  .category-info {
    .category {
      color: ${({ theme }) => theme.color.primary};
      font-size: 16px;
      font-weight: 700;
      & + .summary {
        margin-top: 12px;
        color: ${({ theme }) => theme.color.primary};
      }
    }
  }
  .content-info {
    margin-top: 16px;
    .summary {
      color: ${({ theme }) => theme.color.primary};
      ${({ theme }) => theme.textOverflow.singleLine()}
    }
  }
  .sub-info {
    margin-top: 10px;
    .shop-type {
      color: #747474;
      & + .shop-name {
        position: relative;
        margin-left: 10px;
        padding-left: 10px;
        &::after {
          position: absolute;
          left: -1px;
          top: 1px;
          content: "";
          display: block;
          width: 2px;
          height: 16px;
          background-color: ${({ theme }) => theme.color.lineSecondary};
        }
      }
    }
    .shop-name {
      color: #000;
      margin-right: 15px;
      > svg {
        position: relative;
        top: -1px;
        margin-left: 3px;
      }
    }
    .date {
      padding-right: 16px;
      color: #747474;
      font-family: "Poppins";
      font-weight: 400;
    }
    .chat {
      padding-left: 4px;
      flex-shrink: 0;
      color: #747474;
      font-family: "Poppins";
      font-weight: 400;
      &.new {
        color: ${({ theme }) => theme.color.subMain};
      }
      > svg {
        position: relative;
        left: -4px;
        top: -1px;
      }
    }
  }
`;

const RemarkCom = styled.span`
  display: inline-block;
  padding: 2px;
  margin-right: 8px;
  background-color: #dbe1f4;
  font-size: 12px;
  line-height: 1;
  text-align: center;
`;

export default AsListItem;
